// extracted by mini-css-extract-plugin
module.exports = {"opacityTransition":"l6"};